import { ArrowRepeat } from "react-bootstrap-icons";

interface SkeletonLoaderProps {
    text?: string
}

export function SkeletonLoader({text}:SkeletonLoaderProps): JSX.Element {
    return (
        <div className="flex flex-col items-center justify-center h-full overflow-auto max-h-full grow max-sm:w-full ml-8 max-sm:m-0">
            <h1 className="text-3xl max-sm:text-xl font-bold mb-4 mt-4 text-justify animate-pulse">
                {text ?? 'Loading...'}
            </h1>
            <ArrowRepeat className="w-10 h-10 animate-spin"/>
        </div>
    );
}